<template>
    <vs-popup :active.sync="isActive" v-esc="escape" :title="cloneNewOffSet == null ? 'Mahsup Oluşturuluyor':'Mahsup Güncelleniyor'">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12">
          <v-select :disabled="cloneNewOffSet!=null" class="w-full" name="Ödeme Tipi" placeholder="Ödeme Tipi" v-model="newOffSet.fullType"
                    itemid="id" label="name" v-validate="'required'" :options="paymentMethods" :clearable="false" />
          <span class="text-danger text-sm" v-show="errors.has('Ödeme Tipi')">{{ errors.first('Ödeme Tipi') }}</span>
        </vs-row>
        <vs-row vs-type="flex" v-show="12" class="mt-4">
            <v-select :disabled="cloneNewOffSet!=null" id="branch"  name="Şube" v-validate="'required'" :clearable="false"
              v-model="newOffSet.branch" itemid="id" label="name" placeholder="Şube Seçimi.." :options="branches"
              class="w-full" ></v-select>
            <span class="text-danger text-sm"
              v-show="errors.has('form-2.Şube')">{{ errors.first('form-2.Şube') }}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-input id="price" name="Tutar" v-validate="{required:true}"
            v-model="newOffSet.amount" class="w-full" placeholder="Tutar" @input="handleInput"/>
          <span class="text-danger text-sm" v-show="errors.has('Tutar')">{{ errors.first("Tutar")}}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-textarea id="decription" name="Açıklama" v-validate="'required|max:100'" v-model="newOffSet.description"
            class="w-full mb-0" label="Açıklama" />
          <span class="text-danger text-sm" v-show="errors.has('Açıklama')">{{ errors.first('Açıklama') }}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
            <vs-button @click="isActive = false;" size="large" color="danger" type="gradient" icon-pack="feather"
              icon="icon-arrow-left" class="bold mr-2">
              Vazgeç
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start">
            <vs-button @click="showPopup" size="large" color="transparent" class="bold bg-success text-white ml-2">
              Onayla
            </vs-button>
          </vs-col>
        </vs-row>
      </vs-row>
      <vs-popup
      class="holamundo"
      title="Kaydetme Onayı"
      :active.sync="showPopupFlag"
      v-esc="closePopup"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Kaydetmek istediğinize eminmisiniz?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="closePopup"
          >Vazgeç</vs-button
        >
        <vs-button
          id="removeButton"
          type="gradient"
          color="success"
          icon-pack="feather"
          @click="submitData"
        >
          Onayla
        </vs-button>
      </vs-row>
    </vs-popup>
    </vs-popup>
  </template>

  <script>

    import {
    getBranchNameList
  } from '@/api/User';
  import {
    createOffSet,updateOffSet
  } from '@/api/BranchWalletTransaction';
    export default {
      props: {
        updateData: {
          required: false,
          type: Object
        }
      },
      data() {
        return {
          isActive: false,
          newOffSet: {},
          paymentMethods: [{id:1,name:'Şubeye Ödeme'},{id:2,name:'Şubeye Kesinti'}],
          branches: [],
          showPopupFlag: false,
          cloneNewOffSet:{}
        }
      },
      mounted() {
        this.getBranchNameList();
        console.log(this.cloneNewOffSet);
      },
      methods: {
        closePopup() {
        this.showPopupFlag = false;
      },
        showPopup: async function () {
          let checker = await this.$validator.validateAll();
         if (!checker) {
          return;
         }
        this.showPopupFlag = true
      },
        getBranchNameList: function () {
        getBranchNameList().then(res => {
          if (res && res.status === 200) this.branches = res.data
          else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Şube Listesi Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Sunucu Bağlantı Hatası',
            text: 'Şube Listesi Yüklenemedi !'
          });
        });
      },
        handleInput() {
      // Girilen değeri kontrol et
      if (this.newOffSet.amount !== null) {
        // Sayı ve en fazla iki ondalık basamak kontrolü
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.newOffSet.amount)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.newOffSet.amount = this.newOffSet.amount.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
      }
    },
        escape() {
          if (this.isActive) this.isActive = false;
        },
        submitData: async function () {
          let checker = await this.$validator.validateAll();
          if (!checker) return;
          this.newOffSet.branchId = this.newOffSet.branch.id;
          this.newOffSet.amount = parseFloat(this.newOffSet.amount);
          this.newOffSet.type = this.newOffSet.fullType.id;
          if (!this.newOffSet.id) {
            createOffSet(this.newOffSet).then(res => {
              if (res && res.status == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı",
                  text: "Başarıyla Eklendi!"
                });
                this.isActive = false;
                this.showPopupFlag = false;
                this.$emit("saveData");
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Eklenemedi !"
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !"
              });
            });
          } else {
            updateOffSet(this.newOffSet).then(res => {
              if (res && res.status == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı",
                  text: "Başarıyla Eklendi!"
                });
                this.isActive = false;
                this.showPopupFlag = false;
                this.$emit("saveData");
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Eklenemedi !"
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !"
              });
            });
          }
        },
        initValues() {
            console.log(this.cloneNewOffSet);
          this.$validator.reset();
          if (this.cloneNewOffSet == null) {
            this.newOffSet = {};
          }else{
            this.newOffSet = _.cloneDeep(this.cloneNewOffSet);
            this.newOffSet.branch = this.branches.find(branch => branch.id === this.newOffSet.branchId);
            this.newOffSet.fullType = this.paymentMethods.find(method => method.id === this.newOffSet.type);
            console.log(this.newOffSet);
          }
        }
      },
      watch: {
        isActive(val) {
          this.initValues();
          if (!val) this.$emit("close");
        }
      },
      created() {
      }
    }

  </script>

  <style>
  .orderLogTimeFilter input {
    padding: .7em .5em !important;
    border-radius: .4rem;
    width: 100% !important;
    height: unset !important;
  }
  #switchScreen{
    z-index: 100001;
  }
  #switchScreen .vs-popup .vs-popup--header {
    display: none !important;
  }

  #switchScreen .vs-popup .vs-popup--content {
    padding: 0 !important;
    /*height: 47vh;*/
  }

  #switchScreen .vs-popup {
    background: transparent !important;
    box-shadow: none !important;
  }

  #switchScreen input {
    font-size: 2rem !important;
    background: #f2f2f2 0% 0% no-repeat padding-box !important;
    text-align: center !important;
    padding: 0.5rem;
  }
  </style>
